import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/zh-cn/services/regulatory-affairs/mdr-transition-support")({
  head: () => buildRouteHead("/zh-cn/services/regulatory-affairs/mdr-transition-support"),
  component: RegulatoryOffering,
});

